import React, { useState } from "react";
import { Link } from "react-router-dom";
import FormProgress from "../../../../common/FormProgress/FormProgress";
import { Button, Icon, Modal } from "antd";
import { getNumberWithoutSpaces } from "../../../../../../common/utils/format";
import showSuccessWindow from "../../../../../../common/components/successPopup/successPopup";
import BtnFormSubmit from "../buttons/BtnFormSubmit";
import { Skeleton } from "antd";
import RequestInfo from "../../common/sections/RequestInfo";
import moment from "moment";

const OfferSideBar = props => {
  const [modalVisible, setVisible] = useState(false);

  function confirmAcceptOffer() {
    setVisible(false);
    showSuccessWindow({
      title: "Предложение открыто!",
      content: `Предложение номер ${getNumberWithoutSpaces(
        props.requestNumber
      )} заказчику ${props.customer} и доступно в личном кабинете!`,
      okText: "Готово",
      icon: <Icon type="check-circle" theme="filled" />,
      closable: false,
      maskClosable: true,
      centered: true,
      className: "employee-success-form"
    });
  }

  const { offer, request } = props;
  const offerStatus = (offer && offer.offerStatus) || null;
  let timeInStops = 0;
  offer &&
    offer.routes &&
    offer.routes.forEach((item, index) => {
      let hours = offer["routeDuration" + index].hours();
      let minutes = offer["routeDuration" + index].minutes();
      timeInStops += hours * 60 + minutes;
    });

  const totalPrice = (predPayPrice = 0, payPrice = 0, postPayPrice = 0) => {
    const predPay =
      (predPayPrice &&
        Array.isArray(predPayPrice) &&
        predPayPrice.length > 0 &&
        predPayPrice
          .map((_, index) => {
            return offer[`predPayPrice${index}`];
          })
          .reduce((acc, curr) => acc + curr)) ||
      0;

    const postPay =
      (predPayPrice &&
        Array.isArray(predPayPrice) &&
        predPayPrice.length > 0 &&
        predPayPrice
          .map((_, index) => {
            return offer[`postPayPrice${index}`];
          })
          .reduce((acc, curr) => acc + curr)) ||
      0;

    return predPay + payPrice + postPay;
  };
  return (
    <>
      {props.typeForm !== "view" ? (
        <div className="sidebar">
          <BtnFormSubmit
            disabled={props.disabled}
            onClick={props.handleSubmit}
            onClickTemplate={props.handleSubmitTemplate}
            typeForm={props.typeForm}
          />
          <div className="sidebar-info">
            <RequestInfo request={request} {...props} />
          </div>
          <div className="offer-card__progress">
            <FormProgress progress={props.progress} />
          </div>
          <Button
            ghost
            type="danger"
            htmlType="submit"
            size="large"
            className="offer-card-btn"
            onClick={() => props.handleCancel()}
          >
            Отмена
          </Button>
          <Modal
            visible={modalVisible}
            title={
              <div>
                <Icon style={{ color: "#323232" }} type="question-circle" />{" "}
                Внимание!
              </div>
            }
            onOk={() => {}}
            onCancel={() => {}}
            className="modal-template modal-open-offer"
            centered={true}
            footer={[
              <Button
                key="cancel"
                type="primary"
                ghost
                onClick={() => setVisible(false)}
              >
                Отмена
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => confirmAcceptOffer()}
              >
                Подтвердить
              </Button>
            ]}
          >
            Вы действительно хотите открыть предложение <br />{" "}
            {getNumberWithoutSpaces(props.requestNumber)} заказчику?
          </Modal>
        </div>
      ) : (
        <div className="sidebar">
          <Button
            className="offer-card-btn no-top"
            type="primary"
            ghost
            size="large"
            disabled={!offer || offerStatus === 6}
            onClick={props.handleClickEdit}
          >
            Редактировать предложение
          </Button>
          <Button
            ghost
            type="danger"
            htmlType="submit"
            size="large"
            className="offer-card-btn"
            onClick={() => props.history.goBack()}
          >
            Назад
          </Button>
          <div className="sidebar-info price-info">
            {(offer && offer.payChecked) ||
            (offer && offer.predPayChecked) ||
            (offer && offer.postPayChecked) ? (
              <div className="line-content">
                <span className="line-content__header">
                  {totalPrice(offer.predPay, offer.payPrice, offer.postPay)} ₽
                </span>
                {offer.predPayChecked &&
                  offer.predPay.map((item, index) => {
                    return (
                      <div key={index} className="line-content__row">
                        <div className="line-content__column">
                          <span className="line-content__title">
                            Предоплата
                          </span>
                          <span className="line-content__text">
                            {offer["predPayPrice" + index]} ₽
                          </span>
                        </div>
                        <div className="line-content__column">
                          <span className="line-content__additional">
                            до&nbsp;
                            {offer["predPaymentTime" + index].format(
                              "DD.MM.YYYY"
                            )}
                          </span>
                          <span className="line-content__additional">
                            {offer["predPaymentTime" + index].format("HH:mm")}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                {offer && offer.payPrice && offer.paymentTime && (
                  <div className="line-content__row">
                    <div className="line-content__column">
                      <span className="line-content__title">При посадке</span>
                      <span className="line-content__text">
                        {offer.payPrice} ₽
                      </span>
                    </div>
                    <div className="line-content__column">
                      <span className="line-content__additional">
                        до&nbsp;{offer["paymentTime"].format("DD.MM.YYYY")}
                      </span>
                    </div>
                  </div>
                )}
                {offer.postPayChecked &&
                  offer.postPay.map((item, index) => {
                    return (
                      <div key={index} className="line-content__row">
                        <div className="line-content__column">
                          <span className="line-content__title">
                            Постоплата
                          </span>
                          <span className="line-content__text">
                            {offer["postPayPrice" + index]} ₽
                          </span>
                        </div>
                        <div className="line-content__column">
                          <span className="line-content__additional">
                            до&nbsp;
                            {offer["postPaymentTime" + index].format(
                              "DD.MM.YYYY"
                            )}
                          </span>
                          <span className="line-content__additional">
                            {offer["postPaymentTime" + index].format("HH:mm")}
                          </span>
                        </div>
                      </div>
                    );
                  })}
              </div>
            ) : (
              <Skeleton active />
            )}
          </div>
          <div className="sidebar-info ymaps-info">
            {(offer && (
              <div className="line-content">
                {props.duration && props.distance && props.vehicleUse && (
                  <>
                    <div className="line-content__row">
                      <div className="line-content__column">
                        <span
                          className="line-content__text"
                          style={{ width: "auto" }}
                        >
                          Время в пути (по&nbsp;картам)
                        </span>
                      </div>
                      <div className="line-content__column">
                        <span className="line-content__additional">
                          {props.vehicleUse}
                        </span>
                      </div>
                    </div>
                    <div className="line-content__row">
                      <div className="line-content__column">
                        <span
                          className="line-content__text"
                          style={{ width: "auto" }}
                        >
                          Длина маршрута (по&nbsp;картам)
                        </span>
                      </div>
                      <div className="line-content__column">
                        <span className="line-content__additional">
                          {props.distance}
                        </span>
                      </div>
                    </div>
                    <div className="line-content__row">
                      <div className="line-content__column">
                        <span
                          className="line-content__text"
                          style={{ width: "auto" }}
                        >
                          Время остановок
                        </span>
                      </div>
                      <div className="line-content__column">
                        <span className="line-content__additional">
                          {timeInStops ? `${timeInStops} мин` : "Без остановок"}
                        </span>
                      </div>
                    </div>
                    <div className="line-content__row">
                      <div className="line-content__column">
                        <span
                          className="line-content__text"
                          style={{ width: "auto" }}
                        >
                          Время исп. ТС
                        </span>
                      </div>
                      <div className="line-content__column">
                        <span className="line-content__additional">
                          {props.duration}
                        </span>
                      </div>
                    </div>
                  </>
                )}
                {/*<div className="line-content__row">*/}
                {/*  <div className="line-content__column">*/}
                {/*    <span*/}
                {/*      className="line-content__text"*/}
                {/*      style={{ width: "auto" }}*/}
                {/*    >*/}
                {/*      Время исп. ТС*/}
                {/*    </span>*/}
                {/*  </div>*/}
                {/*  <div className="line-content__column">*/}
                {/*    <span className="line-content__additional">*/}
                {/*      /!*14 час. 42 мин.*!/*/}
                {/*    </span>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {/*<div className="line-content__row">*/}
                {/*  <div className="line-content__column">*/}
                {/*    <span*/}
                {/*      className="line-content__text"*/}
                {/*      style={{ width: "auto" }}*/}
                {/*    >*/}
                {/*      Время остановок*/}
                {/*    </span>*/}
                {/*  </div>*/}
                {/*  <div className="line-content__column">*/}
                {/*    <span className="line-content__additional">*/}
                {/*      /!*{moment(stopTime).format()}*!/*/}
                {/*    </span>*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
            )) || <Skeleton active />}
          </div>

          <div className="sidebar-info offer-info">
            {(offer && (
              <div className="line-content">
                <span className="line-content__header">Статус предложения</span>
                <div className="line-content__row">
                  <div className="line-content__column">
                    <span className="line-content__title">
                      {
                        // offer.vehicleId && offer.driverId ? "Бронь" :
                        // offer.vehilcleId && !offer.driverId ? "Назначение" : "Архив"
                        offer.offerStatusName
                      }
                    </span>
                  </div>
                  <div className="line-content__column">
                    <span className="line-content__additional">
                      до&nbsp;
                      {moment(offer.actionDatetime).format("DD.MM.YYYY")}
                    </span>
                    {offer && offer.offerStatus && (
                      <span
                        className={
                          offer.offerStatus === 4 ||
                          offer.offerStatus === 5 ||
                          offer.offerStatus === 6
                            ? "line-content__text decline"
                            : offer.offerStatus === 7 || offer.offerStatus === 8
                            ? "line-content__text accept "
                            : "line-content__text"
                        }
                      >
                        {offer.offerStatus === 4 ||
                        offer.offerStatus === 5 ||
                        offer.offerStatus === 6
                          ? "Отклонено"
                          : offer.offerStatus === 7 || offer.offerStatus === 8
                          ? "Принято"
                          : "Не принято"}
                      </span>
                    )}
                  </div>
                </div>
                {(offer && offer.offerStatus && offer.offerStatus !== 4) ||
                (offer && offer.offerStatus && offer.offerStatus !== 5) ||
                (offer && offer.offerStatus && offer.offerStatus !== 6) ? (
                  <div className="line-content__row">
                    <div className="line-content__column">
                      <span className="line-content__title">Заявка</span>
                    </div>
                    <div className="line-content__column">
                      <Link
                        to={"/executorship/request/" + offer.requestId}
                        target="_blank"
                        className="line-content__link"
                      >
                        {offer.requestNumber}
                      </Link>
                      {request && request.arrivalDatetime && (
                        <span className="line-content__additional">
                          до&nbsp;
                          {moment(request.arrivalDatetime).format("DD.MM.YYYY")}
                        </span>
                      )}
                    </div>
                  </div>
                ) : (offer && offer.offerStatus && offer.offerStatus === 7) ||
                  (offer && offer.offerStatus && offer.offerStatus === 8) ? (
                  <div className="line-content__row">
                    <div className="line-content__column">
                      <span className="line-content__title">Заказ</span>
                    </div>
                    <div className="line-content__column">
                      <Link
                        to={"/executorship/order/" + offer.orderId}
                        target="_blank"
                        className="line-content__link"
                      >
                        {offer.orderNumber}
                      </Link>
                      {request && request.arrivalDatetime && (
                        <span className="line-content__additional">
                          до&nbsp;
                          {moment(request.arrivalDatetime).format("DD.MM.YYYY")}
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            )) || <Skeleton active />}
          </div>

          <div className="sidebar-info performer-info">
            {(offer && (
              <>
                <div className="line-content">
                  <div className="line-content__row">
                    <div className="line-content__column">
                      <span className="line-content__title">Водитель</span>
                    </div>
                    <div className="line-content__column">
                      {offer.drivers.length > 0 ? (
                        <Link
                          className="line-content__link"
                          key={offer.drivers[0].id}
                          to={`/employees/${offer.drivers[0].id}`}
                        >
                          {offer.drivers[0].userName}
                        </Link>
                      ) : (
                        <span className="line-content__additional">
                          Не назначено
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="line-content__row">
                    <div className="line-content__column">
                      <span className="line-content__title">ТС</span>
                    </div>
                    <div className="line-content__column">
                      {(offer.vehicleId && (
                        <Link
                          to={`/vehicle_card/${offer.vehicleId}`}
                          className="line-content__link"
                        >
                          {offer.vehicle}
                        </Link>
                      )) ||
                        "Не назначено"}
                    </div>
                  </div>
                  <div className="line-content__row">
                    <div className="line-content__column">
                      <span className="line-content__title">Ответств.</span>
                    </div>
                    <div className="line-content__column">
                      {(offer.dispatcherName && (
                        <Link
                          to={`/employees/${offer.dispatcher}`}
                          className="line-content__link"
                        >
                          {offer.dispatcherName}
                        </Link>
                      )) ||
                        "Не назначено"}
                    </div>
                  </div>
                </div>
              </>
            )) || <Skeleton active />}
          </div>
        </div>
      )}
    </>
  );
};

export default OfferSideBar;
